import PropTypes from 'prop-types';
import React from 'react';
import styles from './Header.scss';

const Filters = ({ propertyTypesString, priceString, areaString }) => (
  <span>
    {priceString !== '' &&
    <span>
      <span className={styles.divider} />
      <span>{priceString}</span>
    </span>
    }
    {areaString !== '' &&
    <span className={styles.areaWrapper}>
      <span className={styles.divider} />
      <span className={`${styles.areaIcon} rui-icon rui-icon-left RCAIconArea`}>{areaString}</span>
    </span>
    }
    {propertyTypesString !== '' &&
    <span>
      <span className={styles.divider} />
      <span>{propertyTypesString}</span>
    </span>
    }
  </span>
);

Filters.propTypes = {
  propertyTypesString: PropTypes.string,
  priceString: PropTypes.string,
  areaString: PropTypes.string,
};

export default Filters;
